import { render, staticRenderFns } from "./extcustomerTemp.vue?vue&type=template&id=2630383a&scoped=true&"
import script from "./extcustomerTemp.vue?vue&type=script&lang=js&"
export * from "./extcustomerTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2630383a",
  null
  
)

export default component.exports